<template>
	<div class="modal-container width-100 display-flex flex-column" :style="{ 'max-width': maxWidth }">
		<div class="header-container width-100 flex-centerize">{{ title }}</div>
		<div class="content-container flex-centerize flex-column text-center">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'MessageBox',
	props: {
		title: { type: String },
		triggerEvent: { type: String },
		maxWidth: { type: String },
	},
};
</script>

<style scoped lang="scss">
$overlay-z-index: 50;
$border-radius: 17px;
$inner-border-radius: ($border-radius - 1px);

.modal-container {
	border: 1px solid var(--dismiss-all-grey-color);
	border-radius: $border-radius;
}
.header-container {
	background: #5b5be7;
	border: 1px solid #5b5be7;
	border-radius: $inner-border-radius $inner-border-radius 0 0;
	height: 89px;
	font-weight: 600;
	font-size: 16px;
	letter-spacing: 0;
	color: #ffffff;
}
.content-container {
	background: #ffffff;
	padding: 20px 30px 14px 30px;
	color: #262626;
	letter-spacing: 0;
	font-size: 14px;
	border-radius: 0 0 $inner-border-radius $inner-border-radius;

	::v-deep(.title-cont) {
		font-weight: 600;
	}
	::v-deep(.event-description) {
		opacity: 0.5;
	}
	::v-deep(.end-description) {
		font-size: 11px;
	}
}
</style>
